export const isSmartPhone = () => {
  if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    return true;
  } else {
    return false;
  }
}

const isMacOS = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if(ua.indexOf("windows nt") !== -1) {
    return false
  } else if(ua.indexOf("android") !== -1) {
    return false
  } else if(ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
    return false
  } else if(ua.indexOf("mac os x") !== -1) {
    return true
  } else {
    return false
  }
}
const isSafari = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if(ua.indexOf("edge") !== -1 || ua.indexOf("edga") !== -1 || ua.indexOf("edgios") !== -1) {
    return false
  } else if (ua.indexOf("opera") !== -1 || ua.indexOf("opr") !== -1) {
    return false
  } else if (ua.indexOf("samsungbrowser") !== -1) {
    return false
  } else if (ua.indexOf("ucbrowser") !== -1) {
    return false
  } else if(ua.indexOf("chrome") !== -1 || ua.indexOf("crios") !== -1) {
    return false
  } else if(ua.indexOf("firefox") !== -1 || ua.indexOf("fxios") !== -1) {
    return false
  } else if(ua.indexOf("safari") !== -1) {
    return true
  } else if (ua.indexOf("msie") !== -1 || ua.indexOf("trident") !== -1) {
    return false
  } else {
    return false
  }
}
export const isMacOSSafari = () => {
  return isMacOS() && isSafari()
}